<template>
  <div id="Admin">

    <p v-if="!ready">{{ $t('message.loading') }}</p>

    <section
      v-else
      style="padding: 10px;font-size: 13px;">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <h4>รูปแบบธุรกิจ</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <GChart
                :data="chartData1"
                :options="{
                  title: 'รูปแบบ',
                  pieHole: 0.5,
                  width: 600,
                  height: 600
                }"
                width="800"
                type="PieChart"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <h4>ประเภทธุรกิจ</h4>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <GChart
                :data="chartData2"
                :options="{
                  title: 'กิจการเจ้าของคนเดียว',
                  pieHole: 0.5,
                  width: 600,
                  height: 600
                }"
                width="800"
                type="PieChart"
              />
            </div>
            <div class="col-6">
              <GChart
                :data="chartData3"
                :options="{
                  title: 'บริษัท / ห้างหุ้นส่วน',
                  pieHole: 0.5,
                  width: 600,
                  height: 600
                }"
                type="PieChart"
              />
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  name: 'AdminAnalyticsBusnessType',

  components: {
    GChart,
  },

  data () {
    return {
      ready: false,
    }
  },

  computed: {
    chartData1 () {
      let data = [
        ['Type', 'Count'],
      ]

      let responseData = this.$store.getters['analytic/getState']('businessType')

      for (let item of responseData) {
        let column = this.$t(`business.form.${item.form_id}`)
        let count = item.count
        data.push([column, count])
      }

      return data
    },

    chartData2 () {
      let data = [
        ['Type', 'Count'],
      ]

      let responseData = this.$store.getters['analytic/getState']('businessCategory')

      for (let item of responseData) {
        if ((item.type_id <= 100 || item.type_id == 300) && item.type_id !== null) {
          let column = this.$t(`business.type.${item.type_id}`)
          let count = item.count
          data.push([column, count])
        }
      }

      return data
    },

    chartData3 () {
      let data = [
        ['Type', 'Count'],
      ]

      let responseData = this.$store.getters['analytic/getState']('businessCategory')

      for (let item of responseData) {
        if ((item.type_id >= 101 && item.type_id < 300) && item.type_id !== null) {
          let column = this.$t(`business.type.${item.type_id}`)
          let count = item.count
          data.push([column, count])
        }
      }

      return data
    },
  },

  async created () {
    await this.$store.dispatch('analytic/getBusinessType')
    await this.$store.dispatch('analytic/getBusinessCategory')
    this.ready = true
  },

}
</script>



// WEBPACK FOOTER //
// src/components/admin/analytics/BusinessType.vue